import { Box, Typography } from '@mui/material';
import theme from '../../theme';

const RejectionCard = ({ text }: { text: string }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#fde3e3ff',
      padding: 2,
      borderRadius: 1,
      borderLeft: '4px solid #7e2b2bff',
      maxWidth: '80%',
    }}
  >
    <Typography
      variant="body1"
      sx={{
        color: theme.palette.primary.main,
        fontSize: '1rem',
      }}
    >
      {`Comment: ${text}`}
    </Typography>
  </Box>
);

export default RejectionCard;
